<!--
作业详情页面,静态完成,缺少接口
-->
<template>
  <div class="CatWebPcIndex">

    <!-- 详情信息 -->
    <div class="info-card">
      <!-- 作业名称 -->

      <div class="job-box">

        <el-breadcrumb v-if="studentWork !== 1" separator="/">
          <el-breadcrumb-item :to="{ name: 'myTestJob' }">{{ $t('jobManagementV2.jobManagement') }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('jobManagementV2.myHomework') }}</el-breadcrumb-item>
        </el-breadcrumb>

        <el-breadcrumb v-if="studentWork == 1" separator="/">
          <el-breadcrumb-item :to="{ name: 'studentTask' }">
            {{ $t('jobManagementV2.studentsHomework') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('jobManagementV2.myHomework') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="back-btn" @click="goback()">
        <span class="back-text">{{ $t('jobManagementV2.goBack') }}</span>
      </div>

      <div class="teacher-side" v-if="studentWork == 1">

        <p class="name">{{ jobInfo.name }}</p>
        <p :class="[jobInfo.finish == 1 ? 'state' : 'state1']">
          <i v-if="jobInfo.finish == 1">{{ $t('projectDetailsV2.completed') }}</i>
          <i v-else>{{ $t('jobManagementV2.incomplete') }}</i>
        </p>
        <p class="schedule">
          <el-progress :percentage="jobInfo.progress || 0"></el-progress>
        </p>
      </div>

      <div class="job-schedule" v-else>
        <p>{{ jobInfo.name }}</p>
        <p>
          <el-progress :percentage="progress || 0"></el-progress>
        </p>
      </div>

      <ul :class="[$i18n.locale === 'zh' ? 'information' : 'enformation']">
        <li>
          <span class="information-title">{{ $t("projectV2.langDesc") }}：</span><span class="information-text">{{
            $i18n.locale === "zh"
            ? jobInfo.sourceLangName + ' — ' + jobInfo.targetLangName
            : $langCase[jobInfo.sourceLang] + ' — ' + $langCase[jobInfo.targetLang] }}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("projectV2.domain") }}：</span><span class="information-text">{{
            $i18n.locale === 'zh' ? jobInfo.domain : $domainCase[jobInfo.domainCode] }}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("jobManagementV2.wordNumber") }}：</span>
          <span v-if="jobInfo.sourceWordNum === 0" class="information-text">{{
            $t("jobManagementV2.fileParsing")
          }}</span>
          <span v-else class="information-text">{{
            jobInfo.sourceWordNum
          }}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("jobManagementV2.sentenceNumber") }}： </span>
          <span class="information-text" v-if="jobInfo.sentCount === 0">{{
            $t("jobManagementV2.fileParsing")
          }}</span>
          <span class="information-text" v-else>{{ jobInfo.sentCount }}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("projectV2.creator") }}： </span>
          <el-tooltip class="item" effect="dark" :content="jobInfo.creator" placement="bottom">
            <span class="information-text creator">{{ jobInfo.creator }}</span>
          </el-tooltip>
        </li>
        <li>
          <span class="information-title">{{ $t("projectV2.createTime") }}： </span><span class="information-text">{{
            jobInfo.createTime }}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("projectV2.limitTime") }}： </span><span class="information-text">{{
            jobInfo.deliveryTime }}</span>
        </li>
      </ul>
    </div>

    <!-- 表格数据 -->
    <div class="table-card">
      <div v-if="userLevel === 1" class="btn-box">
        <div class="btn-box-left">
          <button v-if="!downloadDisplay" class="download-report" @click="getFileDownloadUrl()">
            <span>{{
              $t("jobManagementV2.downloadReport")
            }}</span>
            <img src="./assets/images/download.png" />
          </button>

          <button v-else disabled="disabled" class="download-reportForbidden" @click="getFileDownloadUrl()">
            <span>{{
              $t("jobManagementV2.downloadReport")
            }}</span>
            <img src="./assets/images/download.png" />
          </button>

          <button class="distribution" @click="distribution()">
            <span>{{
              $t("jobManagementV2.distribution")
            }}</span>
            <!-- <img src="./assets/images/distribution.png" /> -->
          </button>
          <button class="edit" @click="edit()">
            <span>{{
              $t("jobManagementV2.editor")
            }}</span>
            <!-- <img src="./assets/images/edit.png" /> -->
          </button>
        </div>
        <div class="btn-box-right">
          <button class="delete" @click="deleteTest()">
            {{ $t("projectV2.delete") }}
          </button>
      </div>
    </div>
    <el-table height="calc(100% - 60px)" :data="tableData" border :header-cell-style="{
      'font-weight': 'bold',
      background: '#F3F7FE',
      height: '50px',
      padding: 0,
      color: '#566087',
    }" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }" @sort-change="sortChange">
        <el-table-column :resizable='false' :label="$t('projectV2.index')" width="69" align="center">
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('jobManagementV2.userName')" align="center" prop="userName">
        </el-table-column>
        <el-table-column :resizable='false' sortable :label="$t('jobManagementV2.finishTime')" align="center"
          :show-overflow-tooltip="true" prop="finishTime">
          <template slot-scope="scoped">
            <span v-if="!scoped.row.finishTime">-</span>
            <span v-else class="finish-time-text">{{
              scoped.row.finishTime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' class="progress-item" :label="$t('jobManagementV2.jobProgress')"
          align="center" width="300">
          <template slot-scope="scoped">
            <el-progress :percentage="scoped.row.progress || 0"></el-progress>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('projectV2.state')" width="190" align="center" prop="finish">

          <template slot-scope="scoped">
            <div v-if="scoped.row.finish === 1" class="completed">

              <span>{{ $t("jobManagementV2.completed") }}</span>
            </div>
            <div v-if="scoped.row.finish === 0" class="incomplete">

              <span>{{ $t("jobManagementV2.notStarted") }}</span>
            </div>
            <div v-if="scoped.row.finish === 2" class="underway">

              <span>{{ $t("jobManagementV2.ongoing") }}</span>
            </div>
            <div v-if="scoped.row.finish === 3" class="overdue">

              <span>{{ $t("jobManagementV2.overdue") }}</span>
            </div>
            <div v-if="scoped.row.finish === 4" class="overdueComplete">

              <span>{{ $t("jobManagementV2.overdueComplete") }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :resizable='false' :label="$t('projectV2.operation')" width="227" align="center">
          <template slot-scope="scoped">
            <el-tooltip class="item" effect="dark" :content="$t('projectV2.check')" placement="top">
              <div class="check"><span @click="toEdit(scoped.row)"></span></div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 编辑弹窗 -->
    <edit-dialog :listLength="listLength" @getjobInfo="getjobInfo"></edit-dialog>

    <!-- 分配弹窗 -->
    <distribution-dialog></distribution-dialog>

    <!-- 删除弹窗 -->
    <deleteFile :deleteVisible="isShow" @deleteCancel="isShow = false" @handleOk="confirmdDeletion"
      :content="$t('jobManagementV2.deleteOperation')"></deleteFile>

  </div>
</template>

<script>
import deleteFile from "../../components/layer/fileDialog/deleteFile";
import EditDialog from "../../components/layer/studentJob/editDialog";
import DistributionDialog from "../../components/layer/studentJob/distributionDialog";
import { deleteProject } from "../../services/myProjectApi";
import {
  getWorkReport,
  queryFile,
  queryMyTaskPage,
  queryProjectTermMemoryList,
  queryTaskPage,
} from "@/services/jobManagement";

export default {
  name: "CatWebPcIndex",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.path = from.path;
    });
  },
  components: {
    EditDialog,
    DistributionDialog,
    deleteFile,
  },
  data() {
    return {
      path: null,
      isShow: false,
      tableData: [],
      jobInfo: {
        domain: "",
        domainCode: "",
        name: "",
        deliveryTime: "",
        createTime: "",
        sourceLang: "",
        sourceLangName: "",
        targetLang: "",
        targetLangName: "",
        creator: "",
        sourceWordNum: "",
        finish: "",
        progress: "",
      },
      sourceWordNum: null,
      pageReqDto: {},
      fileId: null,
      dialogVisible: true,
      userLevel: 1,
      listLength: null,
      downloadDisplay: true,
      studentWork: null,
      progress: 0,
      queryData: {},
    };
  },
  created() {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    // console.log(this.queryData)
    if (this.queryData.job == 1) {
      this.studentWork = 1;
    }
    if (this.queryData.userLevel) {
      this.userLevel = this.queryData.userLevel;
    }
    this.queryProjectInfo();
    this.queryFileInfo();
  },
  mounted() { },

  methods: {
    getjobInfo() {
      this.queryProjectInfo()
    },
    //排序
    sortChange({ prop, order }) {
      if (order == "descending") {
        order = "desc";
      } else if (order == "ascending") {
        order = "asc";
      } else if (order === null) {
        order = "asc";
      }
      if (prop === 'finishTime') {
        // this.getManagementPage();
        this.sort = { finishTime: order }
        this.queryStudentPro()
      }
    },
    // 查询项目详情---姓名,领域,截止时间
    queryProjectInfo() {
      // console.log(this.queryData);
      let params = {
        id: this.queryData.id,
      };
      queryProjectTermMemoryList(params).then(({ result }) => {
        this.jobInfo.domain = result.domain;
        this.jobInfo.domainCode = result.domainCode
        this.jobInfo.name = result.name;
        this.jobInfo.deliveryTime = result.deliveryTime;
        this.jobInfo.sourceLang = result.sourceLang
        this.jobInfo.sourceLangName = result.sourceLangName;
        this.jobInfo.targetLang = result.targetLang
        this.jobInfo.targetLangName = result.targetLangName;
        this.jobInfo.creator = result.creator;
        this.jobInfo.createTime = result.createTime;
        this.jobInfo.startTime = result.startTime;
        this.jobInfo.finish = result.finish;
        this.jobInfo.progress = result.progress;
      });
    },
    // 获取字数
    queryFileInfo() {
      let params = { id: this.queryData.id };
      queryFile(params).then(({ result }) => {
        this.jobInfo.sourceWordNum = result[0].sourceWordNum;
        this.jobInfo.sentCount = result[0].sentCount;
        this.fileId = result[0].id;
      });
    },
    // 分配
    distribution() {
      if (new Date() > new Date(this.jobInfo.deliveryTime)) {
        this.$message.closeAll()
        this.$message.warning(this.$t('jobManagementV2.jobDeadline'))
        return
      }
      let busParams = {
        dialogVisible: this.dialogVisible,
        limitTime: this.jobInfo.deliveryTime,
        id: this.fileId,
      };
      this.bus.$emit("busParams", busParams);
    },
    // 编辑
    edit() {
      let params = {
        dialogVisible: this.dialogVisible,
        id: this.queryData.id,
        fileId: this.fileId,
      };
      this.bus.$emit("params", params);
    },
    // 序号格式化
    getIndex($index) {
      (this.pageReqDto.page - 1) * this.pageReqDto.rows + $index + 1;
      if ($index < 9) {
        return "0" + ($index + 1);
      } else {
        return $index + 1;
      }
    },
    // 返回
    goback() {
      if (this.queryData.userLevel == 2) {
        this.$router.push({ name: "myTestJob" });
      } else {
        this.$router.push({ name: "studentTask" });
      }
    },
    // 根据文件id查询学生进度
    queryStudentPro() {
      let params = {
        rows: 1000,
        filter: {
          sourceType: 1,
          fileId: this.fileId,
          companyCode: this.queryData.companyCode,
          projectId: this.queryData.id,
        },
      };
      if (this.userLevel === 1) {
        queryTaskPage(params).then(({ list }) => {
          if (list.length > 0) {
            this.downloadDisplay = false;
          }

          this.listLength = list.length
          let obj = {};
          this.tableData = list.reduce((cur, next) => {
            obj[next.userId] ? "" : (obj[next.userId] = true && cur.push(next));
            return cur;
          }, []);
          if (this.tableData.length > 0) {
            this.progress = this.tableData[0].progress || 0
          }
        });
      } else {
        queryMyTaskPage(params).then(({ list }) => {
          let obj = {};
          this.tableData = list.reduce((cur, next) => {
            obj[next.userId] ? "" : (obj[next.userId] = true && cur.push(next));
            return cur;
          }, []);
          if (this.tableData.length > 0) {
            this.progress = this.tableData[0].progress || 0
          }
        });
      }
    },
    getFileDownloadUrl() {
      getWorkReport({ id: this.fileId }).then(
        ({ result, success, status, errorDesc }) => {
          if (success && status == 200) {
            window.location.href = result;
          } else {
            this.$message.closeAll();
            this.$message.error(errorDesc);
            return;
          }
        }
      );
    },
    deleteTest() {
      this.isShow = true;
    },
    confirmdDeletion() {
      deleteProject({ id: this.queryData.id }).then(({ success }) => {
        if (success) {
          this.$message.closeAll()
          this.$message.success(this.$t("projectV2.success"));
          this.isShow = false;
          this.$router.push({ name: "studentTask" });
        } else {
          this.$message.closeAll()
          this.$message.warning(this.$t("projectV2.error"));
        }
      });
    },
    toEdit(row) {
      let userRole = "";
      if (this.userLevel === 1) {
        userRole = "teacher-homework";
      } else {
        userRole = "student-homework";
      }
      let path = "/neweditor";
      let obj = Object();
      let userId = JSON.parse(localStorage.getItem("userInfo")).id;
      Reflect.set(obj, 'sourceLang', (row.sourceLang));
      Reflect.set(obj, 'targetLang', (row.targetLang));
      Reflect.set(obj, 'taskName', (row.taskName));
      sessionStorage.setItem("fileName", row.taskName)
      Reflect.set(obj, 'wordNum', (row.sourceWordNum));
      Reflect.set(obj, 'project', 3);
      Reflect.set(obj, 'userId', (userId || ''));
      Reflect.set(obj, 'transStatus', 1);
      Reflect.set(obj, 'fileSuffix', row.fileUsableSuffix);
      Reflect.set(obj, 'transModel', row.transModel);
      //老版参数
      Reflect.set(obj, "fileId", row.fileId);
      Reflect.set(obj, "projectId", row.projectId);
      Reflect.set(obj, "isSplit", true);
      Reflect.set(obj, "type", "school");
      Reflect.set(obj, "taskType", row.taskType);
      Reflect.set(obj, "taskId", row.id);
      Reflect.set(obj, "type-school", userRole);
      Reflect.set(obj, "companyCode", this.queryData.companyCode);
      let routeData1 = this.$router.resolve({
        path,
        query: {
          key: this.$Base64.encode(JSON.stringify(obj)),
        },
      });
      window.open(routeData1.href, "_self");
    },
  },
  watch: {
    fileId: {
      handler() {
        this.queryStudentPro();
      },
    },
  },
};
</script>

<style lang="less" scoped>@import "./assets/style.less";</style>
